import { injectable } from 'inversify';

import { getInitials } from '@vk-hr-tek/ui/format';

import { BirthdayEmployee } from '@app/gen/dashboard';

export interface ProcessedBirthdayEmployee extends BirthdayEmployee {
  isToday: boolean;
  formattedDate: string;
  initials: string;
}

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
};

@injectable()
export class BirthdaysMapper {
  processBirthdaysList(
    employees: BirthdayEmployee[],
  ): ProcessedBirthdayEmployee[] {
    const today = new Date();
    const todayMonth = today.getMonth();
    const todayDay = today.getDate();

    return employees
      .map((employee) => {
        const date = new Date(employee.birthday);
        const isToday =
          date.getMonth() === todayMonth && date.getDate() === todayDay;

        return {
          ...employee,
          isToday,
          initials: getInitials(employee.name),
          formattedDate: new Intl.DateTimeFormat(
            'ru-RU',
            DATE_FORMAT_OPTIONS,
          ).format(date),
        };
      })
      .sort((a, b) => {
        const dateA = new Date(a.birthday);
        const dateB = new Date(b.birthday);

        if (dateA.getMonth() !== dateB.getMonth()) {
          return dateA.getMonth() - dateB.getMonth();
        }

        if (dateA.getDate() !== dateB.getDate()) {
          return dateA.getDate() - dateB.getDate();
        }

        return a.name.localeCompare(b.name, 'ru');
      });
  }
}
